"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectStatus = void 0;
var ConnectStatus;
(function (ConnectStatus) {
    /**
     * 初始化状态
     */
    ConnectStatus["INIT"] = "INIT";
    /**
     * bind post 请求中
     */
    ConnectStatus["LOGIN"] = "LOGIN";
    /**
     * bind post 请求失败
     */
    ConnectStatus["LOGIN_FAIL"] = "LOGIN_FAIL";
    /**
     * 登录成功后，bind get 请求中
     */
    ConnectStatus["LOGINED"] = "LOGINED";
    /**
     * 已连接
     */
    ConnectStatus["CONNECTED"] = "CONNECTED";
    /**
     * 已断开（因为后台返回明确的错误码，主动停止请求）
     */
    ConnectStatus["DISCONNECT"] = "DISCONNECT";
    /**
     * 连接失败后重连
     * 可能是以下情形中的一种或多种：
     *  1.获取token失败；
     *  2.save 上行请求失败；
     *  3.bind 下行请求失败；
     */
    ConnectStatus["WAIT_RECONNECTING"] = "WAIT_RECONNECTING";
})(ConnectStatus || (ConnectStatus = {}));
exports.ConnectStatus = ConnectStatus;
